import React from 'react';

import * as S from './FareBreakup.styles';

import RupeeIcon from '../../../../Icons/RupeeIcon';

const FareBreakup = ({fareBreakup, totalAmount}) => {
  return (
    <S.FareBreakUpTipOuterWrap>
      <S.FareBreakUpInnerWrap>
        <S.TotalPriceWrap>
          <S.TotalPriceInfoWrap>
              <S.TotalPriceText>Total Room Price</S.TotalPriceText>
              <S.TotalPriceText>{totalAmount ? totalAmount.toLocaleString('en-IN') : '-'}</S.TotalPriceText>
          </S.TotalPriceInfoWrap>
          <S.OfferBreakupWrap>
            {fareBreakup.map((item, i) => {
              return (
                <S.OfferBreakupInnerWrap key={`${i}${item.k}`}>
                  <S.BreakupText>{item.k}</S.BreakupText>
                  <S.BreakupPrice>{item.s}{item.v}</S.BreakupPrice>
                </S.OfferBreakupInnerWrap>
              );
            })}
          </S.OfferBreakupWrap>
        </S.TotalPriceWrap>
      </S.FareBreakUpInnerWrap>
    </S.FareBreakUpTipOuterWrap>
  );
};

export default FareBreakup;
